import { Box, Typography } from '@material-ui/core'
import { Logo } from 'components/page/logo'
import { useLocation } from 'react-router-dom'
import SignIn from 'pages/auth/SignIn'
import { FunctionComponent } from 'react'
import { BackendUser, UserRoles } from 'common/types'
//@ts-ignore
import { useTheme } from 'styled-components'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'

interface LoginProps {
  title?: string
  tabIndex: number
  selectedPage: number
  setSelectedPage: Function
  setSelectedTab?: Function
  onSubmit: Function
  mode: UserRoles
  username?: string
  password?: string
  setUsername?: Function
  setPassword?: Function
  onLogin: Function
  user: BackendUser
  confirmEmail?: Function
  errorCount?: number
  setErrorCount?: Function
  setShowTicketModal?: Function
  success?: boolean
  setSuccess?: Function
  setForwardingUrl?: Function
  timer: number
  setTimer: Function
  errorFlag: boolean
  setErrorFlag: Function
  errorMessage: string
  setErrorMessage: Function
  getItem: Function
  clearItem: Function
  showConfirmEmailModal: boolean
  setShowConfirmEmailModal: Function
  isLocked: boolean
  setIsLocked: Function
  handleUsernameChange:Function
  resendConfirmationCode: Function
}

export const Login: FunctionComponent<LoginProps> = ({
  username,
  password,
  setUsername,
  setPassword,
  title,
  tabIndex,
  setSelectedTab,
  mode,
  onSubmit,
  selectedPage,
  setSelectedPage,
  onLogin,
  user,
  confirmEmail,
  errorCount,
  setErrorCount,
  timer,
  setTimer,
  errorFlag,
  setErrorFlag,
  errorMessage,
  setErrorMessage,
  getItem,
  clearItem,
  showConfirmEmailModal,
  setShowConfirmEmailModal,
  isLocked,
  setIsLocked,
  handleUsernameChange,
  resendConfirmationCode
}) => {
  const { pathname } = useLocation()
  const theme = useTheme()
  const { isDevice } = useScreenSizes()

  return (
    <Box display="flex" flexDirection="column" width="100%" alignItems="center">
      <Box minHeight="30%" mt="4em">
        <Logo pathname={pathname} bright size='small' />
      </Box>
        <Typography>
          <Box margin="1em 0em 0.5em" color={theme.colors.accent1} fontWeight="bold">
            {title}
         </Box>
        </Typography>
      {mode == UserRoles.Member && (
        <>
          <SignIn
            username={username}
            password={password}
            setUsername={setUsername}
            setPassword={setPassword}
            title={title}
            tabIndex={tabIndex}
            setSelectedTab={setSelectedTab}
            mode={mode}
            onSubmit={onSubmit}
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
            onLogin={onLogin}
            user={user}
            confirmEmail={confirmEmail}
            errorCount={errorCount}
            setErrorCount={setErrorCount}
            timer={timer}
            setTimer={setTimer}
            errorFlag={errorFlag}
            setErrorFlag={setErrorFlag}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            getItem={getItem}
            clearItem={clearItem}
            showConfirmEmailModal={showConfirmEmailModal}
            setShowConfirmEmailModal={setShowConfirmEmailModal}
            isLocked={isLocked}
            setIsLocked={setIsLocked}
            handleUsernameChange={handleUsernameChange}
            resendConfirmationCode={resendConfirmationCode}
          />
        </>
      )}
    </Box>
  )
}